// workaround for gameroom detection
import { Browsers } from '../constants/Browsers';

export function getBrowserName(): string {
    let browserName = window?.app?.config?.user_browser?.name ?? '';

    if (typeof window?.navigator?.userAgent !== 'undefined') {
        if (window.navigator.userAgent.search(/Facebook/i) !== -1) {
            browserName = 'Gameroom';
        }
    }

    return browserName;
}

export function getIsBrowserName(browserName: Browsers): boolean {
    return getBrowserName().toLowerCase() === browserName;
}
